export enum StationTypeEnum {
  TOWING = "TOWING",
  REP_DAF = "REP_DAF",
  REP_DC = "REP_DC",
  REP_FREE = "REP_FREE",
  REP_VOLVO = "REP_VOLVO",
  REP_IVECO = "REP_IVECO",
  REP_KAES = "REP_KAES",
  REP_KOEGEL = "REP_KOEGEL",
  REP_MAN = "REP_MAN",
  REP_RENAULT = "REP_RENAULT",
  REP_SCANIA = "REP_SCANIA",
  REPAIR = "REPAIR",
  PARKING = "PARKING",
  CLEANING = "CLEANING",
  REFUELING = "REFUELING",
  FERRY = "FERRY",
  TOLL = "TOLL",
  REPAIR_AND_MAINTENANCE = "REPAIR_AND_MAINTENANCE",
  TYRES = "TYRES",
  CUSTOM_CLEARANCE = "CUSTOM_CLEARANCE",
  RENTAL = "RENTAL",
  FERRIES = "FERRIES",
  COMBINED_TRANSPORT = "COMBINED_TRANSPORT",
}
